module.exports = __webpack_public_path__ + "static/media/logo-white.71b8988f.png";